import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { AnimatedLoader } from "./components/Loader/AnimatedLoader";
import Home from "./homePage";
import Home2 from "./homePage2";
export const CONFIGURATOR = "/1";

const ConfiguratorViewer = lazy(() => import("./components/ConfiguratorViewer/ConfiguratorViewer"));

const routeMapFunc = (
  { exact = true, path, Component, componentProps, routes },
  idx
) => {
  return (
    <Route
      path={path}
      exact={exact}
      element={<Component {...componentProps} />}
      key={idx}
    >
      {routes?.map(routeMapFunc)}
    </Route>
  );
};

export const routes = [
  // { path: CONFIGURATOR, Component: ConfiguratorViewer, key: "viewer" },
  { path: '/', Component: Home, key: 'home'},
  { path: '/imagine', Component: Home2, key: 'home2'},
  { path: '/:productId', Component: ConfiguratorViewer, key: 'viewer'}
];

export const Routing = () => {
  return (
    <ErrorBoundary>
       <Suspense
        fallback={
          <AnimatedLoader
            className="bg-white"
            zIndex={1000}
            position="absolute"
            top={0}
            backDrop={"rgba(255, 255, 255, 1"}
          />
        }
      >
        <Routes>{routes.map(routeMapFunc)}</Routes>
      </Suspense>
    </ErrorBoundary>
  );
};
